import React from 'react';
import { RouteConfig } from 'types';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { ListItem, ListItemText, ListItemIcon, Badge, ListItemButton, Typography } from '@mui/material';

interface Props {
  routeConfig: RouteConfig;
}

export const SidebarNavItem = ({ routeConfig }: Props) => {
  const history = useHistory();
  const location = useLocation();

  const handleClick = (e: React.MouseEvent) => {
    // If clicking Dashboard while already on dashboard route, force navigation with state to reset view
    if (routeConfig.path === '/dashboard' && location.pathname === '/dashboard') {
      e.preventDefault();
      history.push('/dashboard', { resetView: true });
    }
  };

  return (
    <ListItem disablePadding className="nestedNavList">
      <ListItemButton
        component={NavLink}
        to={routeConfig.dynamicPath || routeConfig.path}
        className="nestedNavListButton"
        onClick={handleClick}
      >
        {routeConfig.icon && (
          <ListItemIcon className="nestedNavListButtonIcon">
            <routeConfig.icon />
          </ListItemIcon>
        )}

        {routeConfig.isNewFeature ? (
          <Badge
            className="nestedNavListButtonText"
            badgeContent={<Typography variant="caption">NEW</Typography>}
            color="secondary"
          >
            <ListItemText primary={<Typography variant="body1">{routeConfig.name}</Typography>} disableTypography />
          </Badge>
        ) : (
          <ListItemText
            className="nestedNavListButtonText"
            primary={<Typography variant="body1">{routeConfig.name}</Typography>}
            disableTypography
          />
        )}
      </ListItemButton>
    </ListItem>
  );
};
